import { JSX } from 'react'

import { IconProps } from '../../icon'

const More: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 49 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M24 8C20.8355 8 17.7421 8.93838 15.1109 10.6965C12.4797 12.4546 10.4289 14.9534 9.21793 17.8771C8.00693 20.8007 7.69008 24.0177 8.30744 27.1214C8.92481 30.2251 10.4487 33.0761 12.6863 35.3137C14.9239 37.5513 17.7749 39.0752 20.8786 39.6926C23.9823 40.3099 27.1993 39.9931 30.1229 38.7821C33.0466 37.5711 35.5454 35.5203 37.3035 32.8891C39.0616 30.2579 40 27.1645 40 24C40 19.7565 38.3143 15.6869 35.3137 12.6863C32.3131 9.68571 28.2435 8 24 8ZM24 37.7143C21.2876 37.7143 18.6361 36.91 16.3808 35.403C14.1255 33.8961 12.3677 31.7542 11.3297 29.2482C10.2917 26.7423 10.0201 23.9848 10.5492 21.3245C11.0784 18.6642 12.3846 16.2205 14.3025 14.3025C16.2205 12.3846 18.6642 11.0784 21.3245 10.5492C23.9848 10.0201 26.7423 10.2916 29.2482 11.3297C31.7542 12.3677 33.8961 14.1254 35.403 16.3807C36.91 18.6361 37.7143 21.2876 37.7143 24C37.7143 27.6373 36.2694 31.1255 33.6975 33.6975C31.1255 36.2694 27.6373 37.7143 24 37.7143Z'
      fill='black'
    />
    <path
      d='M30.8571 22.8571H25.1429V17.1429C25.1429 16.8398 25.0224 16.5491 24.8081 16.3347C24.5938 16.1204 24.3031 16 24 16C23.6969 16 23.4062 16.1204 23.1919 16.3347C22.9775 16.5491 22.8571 16.8398 22.8571 17.1429V22.8571H17.1429C16.8398 22.8571 16.5491 22.9775 16.3347 23.1919C16.1204 23.4062 16 23.6969 16 24C16 24.3031 16.1204 24.5938 16.3347 24.8081C16.5491 25.0224 16.8398 25.1429 17.1429 25.1429H22.8571V30.8571C22.8571 31.1602 22.9775 31.4509 23.1919 31.6653C23.4062 31.8796 23.6969 32 24 32C24.3031 32 24.5938 31.8796 24.8081 31.6653C25.0224 31.4509 25.1429 31.1602 25.1429 30.8571V25.1429H30.8571C31.1602 25.1429 31.4509 25.0224 31.6653 24.8081C31.8796 24.5938 32 24.3031 32 24C32 23.6969 31.8796 23.4062 31.6653 23.1919C31.4509 22.9775 31.1602 22.8571 30.8571 22.8571Z'
      fill='black'
    />
  </svg>
)

export default More
